import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { IAppConfig } from "#app.config";

export class SentryClient {
    static build(config: IAppConfig) {
        return new SentryClient(config);
    }

    constructor(config: IAppConfig) {
        const { dsn, release } = config.sentry;

        posthog.onFeatureFlags(() => {
            let traceRate = 0;
            if (posthog.isFeatureEnabled("sentry-tracing")) {
                traceRate = 1;
            }

            Sentry.init({
                dsn,
                release,
                environment: config.env,
                integrations: [
                    new Sentry.BrowserTracing({
                        tracePropagationTargets: config.sentry.tracingOrigins,
                    }),
                ],
                tracesSampleRate: traceRate,
            });
        });
    }
}
